import { Icon, Label } from 'semantic-ui-react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const CustomerAckType = ({customerAckType}) => {
    const [t] = useTranslation()

    if (customerAckType === 'AWAITING_ACTION') {
        return (
          <Label
            size="mini"
            color="yellow"
          >
              <Icon name="user"/>
              <Icon name="spinner" loading/>
              {t('order.customerAckType.AWAITING_ACTION')}
          </Label>
        )
    }

    if (customerAckType === 'SUBSTITUTION_REJECTED') {
        return (
          <Label
            size="mini"
            color="red"
          >
              <Icon name="user"/>
              {t('order.customerAckType.SUBSTITUTION_REJECTED')}
          </Label>
        )
    }

    if (customerAckType === 'SUBSTITUTION_APPROVED') {
        return (
          <Label
            size="mini"
            color="green"
          >
              <Icon name="user"/>
              {t('order.customerAckType.SUBSTITUTION_APPROVED')}
          </Label>
        )
    }

    if (customerAckType === 'NO_ANSWER') {
        return (
          <Label
            size="mini"
            color="teal"
            basic
          >
              <Icon name="user"/>
              {t('order.customerAckType.NO_ANSWER')}
          </Label>
        )
    }

    if (customerAckType === 'NO_ANSWER_REJECTED') {
        return (
          <Label
            size="mini"
            color="red"
          >
              <Icon name="user"/>
              {t('order.customerAckType.NO_ANSWER_REJECTED')}
          </Label>
        )
    }

    return null
}


CustomerAckType.propTypes = {
    customerAckType: PropTypes.oneOf([
        'AWAITING_ACTION',
        'SUBSTITUTION_REJECTED',
        'SUBSTITUTION_APPROVED',
        'NO_ANSWER',
        'NO_ACK_REQUIRED'
    ]),
}

export { CustomerAckType }
